import { XY } from '../../odie';

import { floatRandom } from '../util/mathTools';

// types
//-----------------------------------------------------------------------------
export type DirectionType = { x?: number; y?: number };
export type PositionType = { x?: number; y?: number } & XY;
export type XyType = DirectionType | PositionType;
export type SizeType = {
  width?: number;
  height?: number;
  minWidth?: number;
  minHeight?: number;
  maxWidth?: number;
  maxHeight?: number;
};
export type BoundsType = PositionType & SizeType;
export type AlignmentType = {
  left: number;
  right: number;
  top: number;
  bottom: number;
};
export type RangeType = [number, number];
export type DynamicNumber = number | RangeType | (() => number);
export type DynamicXy = XyType | [XyType, XyType];

// handlers
//-----------------------------------------------------------------------------
export type BasicHandler = () => any;
export type BasicAsyncHandler = () => Promise<any>;

// defaults
//-----------------------------------------------------------------------------
export const positionZero = { x: 0, y: 0 };

// helpers
//-----------------------------------------------------------------------------
export function getBoundsCenter(bounds: BoundsType): PositionType {
  return {
    x: bounds.x + (bounds.width ?? 0) / 2,
    y: bounds.y + (bounds.height ?? 0) / 2,
  };
}

export function importDynamicNumber(n: DynamicNumber): number {
  // range
  if (Array.isArray(n)) return floatRandom(n[0], n[1]);
  // function
  if (typeof n === 'function') return n();
  return n;
}

export function importDynamicXy(p: DynamicXy, proportional: boolean): XyType {
  // range
  if (Array.isArray(p)) {
    const r = Math.random();
    return {
      x: floatRandom(p[0].x ?? 0, p[1].x ?? 0, () => r),
      y: floatRandom(
        p[0].y ?? 0,
        p[1].y ?? 0,
        proportional ? () => r : Math.random,
      ),
    };
    // position
  }
  return p;
}
